import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';
import { SHOW_PACKING_SLIP_REPRINT_WARNING_KEY } from '../../pages/settings/printing/constants';

export const selectPrintSettings = (state) => get(state, 'v3Settings');
export const selectLabelPrintSettings = (state) => get(selectPrintSettings(state), 'label');
export const selectPackingSlipSettings = (state) => get(selectPrintSettings(state), 'packing-slip');
export const selectPickListSettings = (state) => get(selectPrintSettings(state), 'pick-list');
export const selectPrintWarningSettings = (state) => get(state, 'printWarningSettings', emptyObject);
export const selectShouldShowPackingSlipRePrintWarning = (state) => {
  const printWarningSettings = selectPrintWarningSettings(state);
  // the default behavior is to show the warning, so if there is no setting value it must be the same as true
  return printWarningSettings?.[SHOW_PACKING_SLIP_REPRINT_WARNING_KEY] !== false;
};

export const selectByKey = (state, { printSettingKey }) => {
  const printSettings = selectPrintSettings(state) || emptyObject;
  return printSettings[printSettingKey] ?? emptyObject;
};
